/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fluffy_Civil_Racoon_PrayInputs */

const fr_fluffy_civil_racoon_pray = /** @type {(inputs: Fluffy_Civil_Racoon_PrayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier la section`)
};

/**

* @param {Fluffy_Civil_Racoon_PrayInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const fluffy_civil_racoon_pray = /** @type {((inputs?: Fluffy_Civil_Racoon_PrayInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fluffy_Civil_Racoon_PrayInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_fluffy_civil_racoon_pray(inputs)
});